import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { apiClient, fleetPath } from '@/lib/api-client';
import { adaptServerDetail, type ApiServerDetail } from '@/lib/fleet-adapters';
import type { ServerDetail } from '@/types/fleet';

import { fleetKeys } from './fleet-keys';

/**
 * GET /servers/:name, adapted. Every writer of `fleetKeys.server(name)` (this
 * hook and the list's hover prefetch) must use it, so the cache never holds the
 * raw camelCase API body.
 */
export async function fetchServerDetail(name: string, signal?: AbortSignal): Promise<ServerDetail> {
  return adaptServerDetail(
    await apiClient.get<ApiServerDetail>(fleetPath(`/servers/${encodeURIComponent(name)}`), signal),
  );
}

export function useFleetServer(
  name: string | undefined,
): UseQueryResult<ServerDetail, Error> {
  return useQuery({
    queryKey: fleetKeys.server(name ?? ''),
    queryFn: ({ signal }) => fetchServerDetail(name as string, signal),
    enabled: Boolean(name),
    refetchInterval: 30_000,
    refetchIntervalInBackground: false,
  });
}
